import { render } from "./WristbandMaintenance.vue?vue&type=template&id=5beb38d4&scoped=true"
import script from "./WristbandMaintenance.vue?vue&type=script&lang=js"
export * from "./WristbandMaintenance.vue?vue&type=script&lang=js"

import "./WristbandMaintenance.vue?vue&type=style&index=0&id=5beb38d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5beb38d4"]])

export default __exports__